/**
 * Punto de entrada del panel.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('No se ha encontrado el contenedor #root del panel.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
